<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2021-12-29 11:31:40
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-14 20:00:06
 * @FilePath: /jy-dashboard-web/src/components/companyProfile/iCountUp.vue
 * @Description: 描述
-->
<template>
  <span />
</template>

<script>
import { CountUp } from 'countup.js'
const typeOf = type => object => Object.prototype.toString.call(object) === `[object ${type}]`
const isFunction = typeOf('Function')
export default {
  __countup__: CountUp,
  name: 'VueCountUp',
  props: {
    delay: {
      type: Number,
      required: false,
      default: 1000
    },
    endVal: {
      type: Number,
      required: true
    },
    options: {
      type: Object,
      required: false,
      default () {
        return {
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: '.',
          prefix: '',
          suffix: ''
        }
      }
    }
  },
  data () {
    return {
      instance: null
    }
  },
  // computed: {},
  watch: {
    endVal: {
      handler (value) {
        const that = this
        if (that.instance && isFunction(that.instance.update)) {
          that.instance.update(value)
        }
      },
      deep: false
    }
  },
  methods: {
    create () {
      const that = this
      if (that.instance) {
        return
      }
      const dom = that.$el
      const instance = new CountUp(
        dom,
        that.endVal,
        that.options
      )
      if (instance.error) {
        // error
        return
      }
      that.instance = instance
      if (that.delay < 0) {
        that.$emit('ready', instance, CountUp)
        return
      }
      setTimeout(() => instance.start(() => that.$emit('ready', instance, CountUp)), that.delay)
    },
    destroy () {
      const that = this
      that.instance = null
    },
    printValue (value) {
      const that = this
      if (that.instance && isFunction(that.instance.printValue)) {
        return that.instance.printValue(value)
      }
    },
    start (callback) {
      const that = this
      if (that.instance && isFunction(that.instance.start)) {
        return that.instance.start(callback)
      }
    },
    pauseResume () {
      const that = this
      if (that.instance && isFunction(that.instance.pauseResume)) {
        return that.instance.pauseResume()
      }
    },
    reset () {
      const that = this
      if (that.instance && isFunction(that.instance.reset)) {
        return that.instance.reset()
      }
    },
    update (newEndVal) {
      const that = this
      if (that.instance && isFunction(that.instance.update)) {
        return that.instance.update(newEndVal)
      }
    }
  },
  mounted () {
    const that = this
    that.create()
    setInterval(() => {
      that.reset()
      that.update(that.endVal)
    }, 8000)
  },
  beforeUnmount () {
    const that = this
    that.destroy()
  }
}
</script>
